/* tslint:disable */
/* eslint-disable */
export enum DigitalWalletCertificateOrderEnum {
  Primary = 'Primary',
  Secondary = 'Secondary'
}
